// Write your code here
import {Button, Li} from './styledComponents'

const GradientDirectionItem = prop => {
  const {props, directionInput, toSetDirection} = prop
  const {displayText, value, directionId} = props
  const toSetDirections = event => {
    toSetDirection(event.target.value)
  }
  const opacit = directionInput === value
  console.log(opacit)
  return (
    <Li>
      <Button
        id={directionId}
        onClick={toSetDirections}
        opaci={opacit}
        value={value}
      >
        {displayText}
      </Button>
    </Li>
  )
}
export default GradientDirectionItem
